import OSS from 'ali-oss'

export function getUserInfo() {
  const $this = this
  this.$http
    .get(window.serverPath + '/api/user/info')
    .then((res) => {
      if (res.data.code === '200') {
        $this.$store.commit('setUserInfo', res.data.data)
      }
    })
    .catch((err) => {
      console.log('异常', err)
    })
}

export function toVerifyPage(query) {
  const nextQuery = query && query.from ? { from: query.from } : {}
  if (this.$store.state.userInfo.level === 0) {
    this.$router.push({ name: 'BasicLevel', query: nextQuery })
  } else if (this.$store.state.userInfo.level === 1) {
    this.$router.push({ name: 'SemiVerified', query: nextQuery })
  } else {
    this.$router.push({ name: 'FullyVerified', query: nextQuery })
  }
}

export async function getAreaCodeByIP() {
  const res = await this.$http.get(window.serverPath + '/api/auth/getIpDetail')
  if (res.data.code === '200') {
    return res.data.data.areaCode
  }
}

export function handleResize() {
  const app = document.getElementById('app')
  if (app) {
    app.style.height = visualViewport.height + 'px'
  }
}

export function uploadToAliyunOss() {
  async function uploadFile(file, onSuccess, onFail) {
    const res = await this.$http.post(window.serverPath + '/api/file/getUploadKey', {})
    const ossInfo = res.data.data
    if (res.data.code === '200') {
      const ossClient = new OSS({
        region: 'oss-ap-southeast-1',
        accessKeyId: ossInfo.ak,
        accessKeySecret: ossInfo.sk,
        bucket: 'fl-wallet-oss',
        stsToken: ossInfo.st
      })
      const fileName = ossInfo.path + '.' + file.name.split('.').pop().toLowerCase()
      await ossClient
        .put(fileName, file)
        .then((res) => {
          if (res.res.status === 200) {
            onSuccess && onSuccess(res)
          }
        })
        .catch((err) => {
          onFail && onFail(err)
          console.error(err)
        })
    }
  }

  return {
    uploadFile
  }
}



// WEBPACK FOOTER //
// ./src/service/index.js